import { BaseModel } from "model/BaseModel";
import { BaseEditModel } from "model/BaseEditModel";
import PlanoAuditoria from "./PlanoAuditoria";
import ItemPlanoAuditoria from "./ItemPlanoAuditoria";

export default class ClassePlanoAuditoria implements BaseEditModel {

    key: string | null = null;
    id: number;
    nome: string;
    nota_maxima: number;
    ativo: boolean;
    itensPlanoAuditoria: ItemPlanoAuditoria[];
    planoAuditoria: PlanoAuditoria;
    sequencial: number | null = null;

    constructor(
        id = 0,
        nome = '',
        nota_maxima = 0,
        ativo = true,
        itensPlanoAuditoria = [],
        planoAuditoria = new PlanoAuditoria()
    ) {
        this.id = id;
        this.nome = nome;
        this.nota_maxima = nota_maxima;
        this.ativo = ativo;
        this.itensPlanoAuditoria = itensPlanoAuditoria;
        this.planoAuditoria = planoAuditoria;
    }
}
